import { Organization, OrganizationMember } from 'types';
import HTTPClient, { HTTPClientParameters } from './HTTPClient';

type OrganizationClientParams = HTTPClientParameters;

class OrganizationClient extends HTTPClient {
    constructor(params: OrganizationClientParams) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }

    getOrganization(id: number | string): Promise<Organization> {
        return this.get(`organizations/${id}/`);
    }

    getOrganizations(): Promise<{ name: string; pk: number }[]> {
        return this.get('organizations/');
    }

    getOrganizationMembers(id: number | string): Promise<OrganizationMember[]> {
        return this.get(`organizations/${id}/members/`);
    }

    deleteOrganizationMember(id: number | string, memberId: number | string): Promise<void> {
        return this.delete(`organizations/${id}/members/${memberId}/`);
    }
}

export default OrganizationClient;
